module.exports = "/img/_/_/_/assets/images/creeper/battle/common//18.jpg?4c6d7cd7fc7f5b61adee1c6e8b28632b";